import React, { Fragment, useState, useEffect } from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useTranslation } from 'react-i18next';
import { ToastContainer, toast } from "react-toastify";
import Cookies from 'js-cookie';
import axios from 'axios';

import "react-toastify/dist/ReactToastify.css";
const { config } = require('../api/api');


function OmanVisaSummary() {


    
  const { t } = useTranslation();
  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
  
  const [formData, setFormData] = useState(null);
 
  const [isLoading, setIsLoading] = useState(false);
  const [vendorKey, setVendorKey] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [userData,setUserData]= useState({});
  const [usrtok,setUsrtok]= useState("");
  const [loading,setLoading]=useState(false);
     const [files, setFiles] = useState({
          passportCopy: null,
          photo1: null,
          photo2: null,
          supportingDocs: null
      });
  const [appId,setAppId]=useState("");
  const base_url = config.baseURL;

     useEffect(()=>{
     const storedUserString = Cookies.get('userData');
      if (storedUserString !== undefined) {
        const user_data = JSON.parse(storedUserString);
       setUserData(user_data);
        setUsrtok(user_data.access_token);
      }
      },[]);

        // ✅ Load SmartBox script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = config.amwalpayURL;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

    const getUserType = () => {
    if (userData.agency_name) return "agent";
    if (userData.type === "staff" && userData.staff_first_name) return "staff";
    if(userData.first_name && userData.last_name)  return "user";
    return "";
  };

   const openPaymentGateway = async (app_id) => {
    if (!app_id || !vendorKey) {
      console.error(" Missing appId or vendorKey");
      return;
    }

    setLoading(true);

    const pay_data = {
      application_id: app_id,
      user_type: getUserType(),
      is_live: "true",
      save_selection: "true",
      currency: "OMR",
      fee_omr: 45,
      description: "Oman Visa Payment",
      token: userData.access_token,
    };

    try {
      const res = await fetch(`${base_url}/create_oman_visa_payment`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${vendorKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(pay_data),
      });

      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

      const result = await res.json();
      if (result.message === "success") {
        const parsedata = JSON.parse(result.result.payment_details);
        const { secureHash, trxParams } = parsedata;

        if (!window.SmartBox || !window.SmartBox.Checkout) {
          throw new Error("SmartBox payment gateway not loaded");
        }

        window.SmartBox.Checkout.configure = {
          MID: trxParams.MerchantId,
          TID: trxParams.TerminalId,
          CurrencyId: trxParams.CurrencyId,
          AmountTrxn: trxParams.Amount,
          MerchantReference: trxParams.MerchantReference,
          LanguageId: "en",
          PaymentViewType: 1,
          TrxDateTime: trxParams.TrxDateTime,
          SessionToken: trxParams.SessionToken,
          SecureHash: secureHash,

          completeCallback: async (data) => {
            try {
              setLoading(true)
              const verifyRes = await axios.post(
                `${base_url}/oman_visa_payment_status`,
                data.data
              );
              if (verifyRes.data.valid) {
                window.location.href = verifyRes.data.data;
                return;
              }
            } catch (err) {
              setLoading(false)
              console.error("Verification failed:", err);
            }
          },

          errorCallback: (error) => {
            console.error("❌ Payment Error:", error);
            setLoading(true);
            window.location.href = `/oman-visa-form-status?application_id=${btoa(app_id)}&payment_status=failed`;
          },

          cancelCallback: (cancel) => {
            console.log("⚠️ Payment Cancelled:", cancel);
            setLoading(false);
          },
        };

        window.SmartBox.Checkout.showSmartBox();
      } else {
        throw new Error(result.message || "Payment creation failed");
      }
    } catch (err) {
      console.error("Error creating payment:", err);
      setLoading(false);
    }finally{
      setLoading(false);
    }
  };


   useEffect(() => {
          const postvData = { organization_name: "Superjet" };
          if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {
              fetch(base_url + '/create_organization', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(postvData),
              })
              .then(response => response.json())
              .then(data => {
                  setVendorKey(data.result[0].vendor_key);
              })
              .catch(error => {
                  console.error('Error posting data:', error);
              });
          }
      }, [vendorKey]);

  useEffect(() => {
    try {
      const storedFormData = sessionStorage.getItem("omanVisaFormData");
      
      if (storedFormData) {
        setFormData(JSON.parse(storedFormData));
      }
    } catch (error) {
      console.error('Error loading form data:', error);
    }
  }, []);

      const handleFileChange = (e) => {
        const file = e.target.files[0];
        const fieldName = e.target.name;
        
        if (!file) return;
        
        // Validate file type
        const allowedTypes = fieldName === 'supportingDocs' 
            ? ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png']
            : fieldName === 'passportCopy'
            ? ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png']
            : ['image/jpeg', 'image/jpg', 'image/png'];
            
        if (!allowedTypes.includes(file.type)) {
            toast.error(`Invalid file type. Please upload ${fieldName === 'passportCopy' || fieldName === 'supportingDocs' ? 'PDF, JPG, or PNG' : 'JPG or PNG'} files only.`);
            e.target.value = '';
            return;
        }
        
        // Validate file size
        const maxSize = fieldName === 'passportCopy' || fieldName === 'supportingDocs' ? 10 * 1024 * 1024 : 5 * 1024 * 1024; // 10MB or 5MB
        if (file.size > maxSize) {
            toast.error(`File size too large. Maximum size is ${fieldName === 'passportCopy' || fieldName === 'supportingDocs' ? '10MB' : '5MB'}.`);
            e.target.value = '';
            return;
        }
        
        setFiles({
            ...files,
            [fieldName]: file
        });
        
        // toast.success(`${fieldName} uploaded successfully!`);
    };

    const handleClickBtnFile = (e, fieldName) => {
        document.getElementById(fieldName).click();
    };

  const handleMakePayment = async(e) => {
debugger
    e.preventDefault();
    if (!formData) {
      alert('No form data found. Please fill the form first.');
      return;
    }

    if (!validateForm()) {
      return;
    }

    
    setLoading(true);
    
      try {

         var  uploaded_document_details=[];
 
         const file_keys= Object.keys(files);
        for(let k=0;k<file_keys.length;k++){

          const each_file=files[file_keys[k]];
          
            const file_name=each_file?.name;
            if(file_name){
            // const extension=file_name.substring(file_name.lastIndexOf('.')).toLowerCase();
            const fileData=new FormData();
            fileData.append("image",each_file);
            fileData.append("document_type",file_keys[k])
            const response = await fetch(base_url+'/upload_documentss3',{
              method:"POST",
              headers:{
                "Authorization":"Bearer "+vendorKey
              },
              body:fileData
            })
            if(response.ok){
            const data=await response.json();
            if(data.message==="File uploaded successfully"){
              //  const get_card_details=localStorage.getItem("added_card_details");
              //  const parse_card=get_card_details && JSON.parse(get_card_details);
            const obj={
                document_type:file_keys[k],
                document: data.fileUrl
            }
            uploaded_document_details.push(obj);
            }
            }
          }
        }
        

        let user_type_check;
        if(userData.agency_name){
          user_type_check="agent";
        }
        else if(userData.type==="staff" && userData.staff_first_name){
          user_type_check="staff";
        }
        else if(userData.first_name && userData.last_name){
          user_type_check="user";
        }
        else{
          user_type_check="";
        }

                  const payload={
                         ...formData,
                         uploadedDocuments:JSON.stringify(uploaded_document_details),
                         token: usrtok ,
                         user_type:user_type_check
                  }
      
                  const response = await fetch(base_url+"/create_oman_visa_form",{
                      method:"POST",
                      headers:{
                          "Authorization":"Bearer "+vendorKey,
                          "Content-Type":"application/json"
                      },
                      body:JSON.stringify(payload)
                  });
      
                  const data = await response.json();
                  if(data.message==="success"){
      
                  console.log(data);
                  if(data.result && data.result.application_id){
                      const app_id = data.result.application_id;
                      setAppId(app_id);
                     setTimeout(()=>{
                      openPaymentGateway(app_id);
                  },1000);

                         
                  }
                  else{
                      toast.error('Application ID not found.');
                  }
                  }
      
                  
      
              } catch (error) {
                  console.log(error)
                  toast.error('Error submitting form. Please try again.');
              }
              finally{
                setIsLoading(false);
                setLoading(false);
              }
  };

    
    const handleBackButton = () => {
    window.location.href = "/oman-visa-form";
  };

    const validateForm = () => {
        debugger
        
          const requiredFiles = ['passportCopy', 'photo1', 'photo2'];
          for (let file of requiredFiles) {
              if (!files[file]) {
                  const element = document.querySelector(`[name="${file}"]`);
                  if (element) {
                      element.focus();
                      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }
                  toast.error(`Please upload ${file.replace(/([A-Z])/g, ' $1').toLowerCase()}`);
                  return false;
              }
          }
                return true;
      };
          
       


      const truncateFileName = (fileName, maxLength = 20) => {
          if (!fileName) return '';
          if (fileName.length <= maxLength) return fileName;
          const extension = fileName.split('.').pop();
          const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.'));
          const truncatedName = nameWithoutExt.substring(0, maxLength - extension.length - 4);
          return `${truncatedName}...${extension}`;
      };
  

      const handleRemoveFile = (fieldName) => {
          setFiles({
              ...files,
              [fieldName]: null
          });
          // Reset the file input
          const fileInput = document.getElementById(fieldName);
          if (fileInput) {
              fileInput.value = '';
          }
      };

      const listStyle= {
        minWidth: '130px',
        fontWeight:"600",
        textAlign:lnstr=="en"?"":"right"
      }
  
  return (
    <Fragment>
      <div className="header_section1">
        <Navbar />
        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{t("Oman Visa Application Summary")}</h3>
          </div>
        </div>
      </div>

      <div className="features_section">
        <div className="container mt-5">
          <div className="row justify-content-center" style={{textAlign:lnstr=="en"?"":"right"}}>
            <div className="col-md-10">
              
              <div className="card">
                <div className="card-header">
                  <h4 className="mb-0">{t("Application Summary")}</h4>
                </div>
                <div className="card-body">
                  
                  {/* Personal Information */}
                  <div className="mb-4">
                    <h5 className="text-primary mb-3" style={{textAlign:lnstr=="en"?"":"right"}}>{t("Personal Information")}</h5>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="d-flex mb-2">
                          <span className="fw-bold" style={listStyle}>{t("Full Name")}</span>
                          <span>:&nbsp;</span><span className="ms-2">{formData?.fullName }</span></div>
                        <div className="d-flex mb-2"><span className="fw-bold" style={listStyle}>{t("Nationality")}</span><span>:&nbsp;</span><span className="ms-2">{lnstr =="en"?formData?.nationality :t(formData?.nationality) }</span></div>
                        <div className="d-flex mb-2"><span className="fw-bold" style={listStyle}>{t("Date of Birth")}</span><span>:&nbsp;</span><span className="ms-2">{formData?.dateOfBirth }</span></div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex mb-2"><span className="fw-bold" style={listStyle}>{t("Gender")}</span><span>:&nbsp;</span><span className="ms-2">{lnstr=="en" ? formData?.gender : t(formData?.gender)}</span></div>
                        <div className="d-flex mb-2"><span className="fw-bold" style={listStyle}>{t("Email")}</span><span>:&nbsp;</span><span className="ms-2">{formData?.email }</span></div>
                        <div className="d-flex mb-2"><span className="fw-bold" style={listStyle}>{t("Origin Mobile")}</span><span>:&nbsp;</span><span className="ms-2">{formData?.originMobileCode +" "+formData?.originMobile || "" }</span></div>
                      </div>
                    </div>
                  </div>

                  {/* Passport Information */}
                  <div className="mb-4">
                    <h5 className="text-primary mb-3" style={{textAlign:lnstr=="en"?"":"right"}}>{t("Passport Information")}</h5>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="d-flex mb-2"><span className="fw-bold" style={listStyle}>{t("Passport Number")}</span><span>:&nbsp;</span><span className="ms-2">{formData?.passportNumber }</span></div>
                        <div className="d-flex mb-2"><span className="fw-bold" style={listStyle}>{t("Issue Date")}</span><span>:&nbsp;</span><span className="ms-2">{formData?.passportIssueDate }</span></div>
                        <div className="d-flex mb-2"><span className="fw-bold" style={listStyle}>{t("Expiry Date")}</span><span>:&nbsp;</span><span className="ms-2">{formData?.passportExpiryDate }</span></div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex mb-2"><span className="fw-bold" style={listStyle}>{t("Country of Issue")}</span><span>:&nbsp;</span><span className="ms-2">{lnstr=="en"?formData?.countryOfIssue : t(formData?.countryOfIssue) }</span></div>
                        <div className="d-flex mb-2"><span className="fw-bold" style={listStyle}>{t("Place of Issue")}</span><span>:&nbsp;</span><span className="ms-2">{formData?.placeOfIssue }</span></div>
                      </div>
                    </div>
                  </div>

                  {/* Travel Information */}
                  <div className="mb-4">
                    <h5 className="text-primary mb-3" style={{textAlign:lnstr=="en"?"":"right"}}>{t("Travel Information")}</h5>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="d-flex mb-2"><span className="fw-bold" style={listStyle}>{t("Entry Date")}</span><span>:&nbsp;</span><span className="ms-2">{formData?.entryDate }</span></div>
                        <div className="d-flex mb-2"><span className="fw-bold" style={listStyle}>{t("Stay Duration")}</span><span>:&nbsp;</span><span className="ms-2">{formData?.stayDuration }</span></div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex mb-2"><span className="fw-bold" style={listStyle}>{t("Visa Type")}</span><span>:&nbsp;</span><span className="ms-2">{lnstr=="en"?formData?.visaType:t(formData?.visaType) }</span></div>
                        <div className="d-flex mb-2"><span className="fw-bold" style={listStyle}>{t("Oman Mobile")}</span><span>:&nbsp;</span><span className="ms-2">{formData?.omanMobileCode+" "+formData?.omanMobile || "" }</span></div>
                      </div>
                    </div>
                  </div>

           

                </div>
              </div>
                     {/* Requirements Section */}
                            <div className="card mt-4 mb-4">
                                   <div className="card-header">
                  <h4 className="mb-0">{t("Documents Required for Oman Tourist Visa")}</h4>
                </div>
                                
                                <div className="card-body" style={{textAlign:lnstr=="en"?"":"right"}}>
                                    <ul className="list-unstyled">
                                        <li>• {t("Passport Copy (valid for 06 months from travel dates)")}</li>
                                        <li>• {t("Travel Insurance (we can arrange at additional cost)")}</li>
                                        <li>• 02 {t("Photos")} ({t("white background")} 5x5 cm)</li>
                                        <li>• {t("Visa Fee and Service Fees are non-refundable")}</li>
                                    </ul>
                                    <p className="text-muted small mt-3 " style={{fontSize:"14px"}}>
                                        <strong>{t("Note")}:</strong> {t(`The grant or refusal of the visa is at the sole discretion of the Royal Oman Police.`)} 
                                        {t(`SuperJet is not involved in the process nor liable for any delay or rejection.`)} 
                                        {t(`The Royal Oman Police reserves the right to ask for further documentation.`)}
                                    </p>
                                </div>
                            </div>

                      <div className="mb-4">
                                            <h4 className="mb-3 text-primary d-flex align-items-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-cloud-upload me-2" viewBox="0 0 16 16">
                                                    <path fillRule="evenodd" d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                                    <path fillRule="evenodd" d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"/>
                                                </svg>
                                                &nbsp;{t("Upload Required Documents")}
                                            </h4>
                                            <p className="text-muted mb-4">{t("Please upload the following documents. Click on each card to select your files.")}</p>
                                        </div>

                                        <div className="row g-4">
                                            <div className="col-lg-6 col-md-12 mb-4">
                                                <div 
                                                    className="upload-zone" 
                                                    style={{
                                                        border: files.passportCopy ? '2px solid #28a745' : '2px dashed #17a2b8',
                                                        borderRadius: '15px',
                                                        padding: '20px 15px',
                                                        textAlign: 'center',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.3s ease',
                                                        backgroundColor: files.passportCopy ? '#f8fff9' : '#f8f9ff',
                                                        minHeight: '150px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'center',
                                                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                                                    }} 
                                                    onClick={() => handleClickBtnFile(null, 'passportCopy')}
                                                >
                                                    <input type="file" name="passportCopy" id="passportCopy" style={{display:"none"}} onChange={handleFileChange} accept=".pdf,.jpg,.jpeg,.png" />
                                                    
                                                    {files.passportCopy ? (
                                                        <div>
                                                            <div className="d-flex justify-content-center mt-2">
                                                               <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#28a745" className="bi bi-check2-circle" viewBox="0 0 16 16">
                                                             <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
                                                             <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
                                                           </svg>
                                                            &nbsp;
                                                            <h5 className="text-success mb-2 fw-bold ">{t("Passport Copy Uploaded")}</h5>
                                                            </div>
                                                            
                                                            <p className="text-muted mb-3 mt-3">{truncateFileName(files.passportCopy.name, 30)}</p>
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-outline-danger btn-sm"
                                                                onClick={(e) => {e.stopPropagation(); handleRemoveFile('passportCopy')}}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash me-1" viewBox="0 0 16 16" style ={{position:"relative",top:"3px"}}>
                                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                                                    <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                                                </svg>
                                                              &nbsp;  {t("Remove")}
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                           <div className="d-flex justify-content-center">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#007bff" className="bi bi-file-earmark-text" viewBox="0 0 16 16" style={{position:"relative",top:"2px"}}>
                                                                    <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/>
                                                                    <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                                                                </svg>
                                                          &nbsp;
                                                            <h5 className="text-primary mb-2 fw-bold">{t("Passport Copy")} <span className="text-danger">*</span></h5>
                                                            </div>
                                                            <p className="text-muted mb-3">{t("Click to upload your passport")}<br/>PDF, JPG, PNG (Max 10MB)</p>
                                                            <div className="btn btn-primary">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-upload me-2" viewBox="0 0 16 16">
                                                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                                                    <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
                                                                </svg> &nbsp;
                                                                {t("Choose File")}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-12 mb-4">
                                                <div 
                                                    className="upload-zone" 
                                                    style={{
                                                        border: files.photo1 ? '2px solid #28a745' : '2px dashed #17a2b8',
                                                        borderRadius: '15px',
                                                        padding: '20px 15px',
                                                        textAlign: 'center',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.3s ease',
                                                        backgroundColor: files.photo1 ? '#f8fff9' : '#f0fdff',
                                                        minHeight: '150px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'center',
                                                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                                                    }} 
                                                    onClick={() => handleClickBtnFile(null, 'photo1')}
                                                >
                                                    <input type="file" name="photo1" id="photo1" style={{display:"none"}} onChange={handleFileChange} accept=".jpg,.jpeg,.png" />
                                                    
                                                    {files.photo1 ? (
                                                        <div>
                                                            <div className="d-flex justify-content-center mt-2">
                                                             <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#28a745" className="bi bi-check2-circle" viewBox="0 0 16 16">
                                                             <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
                                                             <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
                                                           </svg>
                                                            &nbsp;
                                                            <h5 className="text-success mb-2 fw-bold">{t("Photo 1 Uploaded")}</h5>
                                                            </div>
                                                            <p className="text-muted mb-3 mt-3">{truncateFileName(files.photo1.name, 30)}</p>
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-outline-danger btn-sm"
                                                                onClick={(e) => {e.stopPropagation(); handleRemoveFile('photo1')}}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash me-1" viewBox="0 0 16 16"  style ={{position:"relative",top:"3px"}}>
                                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                                                    <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                                                </svg>
                                                              &nbsp;  {t("Remove")}
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <div className="d-flex justify-content-center">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#007bff" className="bi bi-file-earmark-text" viewBox="0 0 16 16">
                                                                    <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/>
                                                                    <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                                                                </svg>
                                                         &nbsp;
                                                            <h5 className="text-primary mb-2 fw-bold">{t("Photo 1")} (5x5 cm) <span className="text-danger">*</span></h5>
                                                               </div>
                                                            <p className="text-muted mb-3">{t("Click to upload your photo")}<br/>JPG, PNG (Max 5MB)</p>
                                                            <div className="btn btn-primary">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-upload me-2" viewBox="0 0 16 16" style={{position:"relative",top:"2px"}}>
                                                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                                                    <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
                                                                </svg> &nbsp;
                                                                {t("Choose File")}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-12 mb-4">
                                                <div 
                                                    className="upload-zone" 
                                                    style={{
                                                        border: files.photo2 ? '2px solid #28a745' : '2px dashed #17a2b8',
                                                        borderRadius: '15px',
                                                        padding: '20px 15px',
                                                        textAlign: 'center',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.3s ease',
                                                        backgroundColor: files.photo2 ? '#f8fff9' : '#f0fdff',
                                                        minHeight: '150px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'center',
                                                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                                                    }} 
                                                    onClick={() => handleClickBtnFile(null, 'photo2')}
                                                >
                                                    <input type="file" name="photo2" id="photo2" style={{display:"none"}} onChange={handleFileChange} accept=".jpg,.jpeg,.png" />
                                                    
                                                    {files.photo2 ? (
                                                        <div>
                                                            <div className="d-flex justify-content-center mt-2">
                                                               <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#28a745" className="bi bi-check2-circle" viewBox="0 0 16 16">
                                                             <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
                                                             <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
                                                           </svg>
                                                            &nbsp;
                                                            <h5 className="text-success mb-2 fw-bold">{t("Photo 2 Uploaded")}</h5>
                                                            </div>
                                                            <p className="text-muted mb-3 mt-3">{truncateFileName(files.photo2.name, 30)}</p>
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-outline-danger btn-sm"
                                                                onClick={(e) => {e.stopPropagation(); handleRemoveFile('photo2')}}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash me-1" viewBox="0 0 16 16"  style ={{position:"relative",top:"3px"}}>
                                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                                                    <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                                                </svg>
                                                               &nbsp; {t("Remove")}
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <div className="d-flex justify-content-center ">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#007bff" className="bi bi-file-earmark-text" viewBox="0 0 16 16">
                                                                    <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/>
                                                                    <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                                                                </svg>
                                                           &nbsp;
                                                            <h5 className="text-primary mb-2 fw-bold">{t("Photo 2")} (5x5 cm) <span className="text-danger">*</span></h5>
                                                               </div>
                                                            <p className="text-muted mb-3">{t("Click to upload your photo")}<br/>JPG, PNG (Max 5MB)</p>
                                                            <div className="btn btn-primary">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-upload me-2" viewBox="0 0 16 16" style={{position:"relative",top:"2px"}}>
                                                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                                                    <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
                                                                </svg> &nbsp;
                                                                {t("Choose File")}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-12 mb-4">
                                                <div 
                                                    className="upload-zone" 
                                                    style={{
                                                        border: files.supportingDocs ? '2px solid #28a745' : '2px dashed #6c757d',
                                                        borderRadius: '15px',
                                                        padding: '20px 15px',
                                                        textAlign: 'center',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.3s ease',
                                                        backgroundColor: files.supportingDocs ? '#f8fff9' : '#f8f9fa',
                                                        minHeight: '150px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'center',
                                                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                                                    }} 
                                                    onClick={() => handleClickBtnFile(null, 'supportingDocs')}
                                                >
                                                    <input type="file" name="supportingDocs" id="supportingDocs" style={{display:"none"}} onChange={handleFileChange} accept=".pdf,.jpg,.jpeg,.png" multiple />
                                                    
                                                    {files.supportingDocs ? (
                                                        <div>
                                                            <div className="d-flex justify-content-center mt-2">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#28a745" className="bi bi-check2-circle" viewBox="0 0 16 16">
                                                             <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
                                                             <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
                                                           </svg>
                                                            &nbsp;
                                                            <h5 className="text-success mb-2 fw-bold">{t("Supporting Docs Uploaded")}</h5>
                                                            </div>
                                                            <p className="text-muted mb-3 mt-3">{truncateFileName(files.supportingDocs.name, 30)}</p>
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-outline-danger btn-sm"
                                                                onClick={(e) => {e.stopPropagation(); handleRemoveFile('supportingDocs')}}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash me-1" viewBox="0 0 16 16"  style ={{position:"relative",top:"3px"}}>
                                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                                                    <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                                                </svg>
                                                               &nbsp; {t("Remove")}
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <div className="d-flex justify-content-center">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#6c757d" className="bi bi-files" viewBox="0 0 16 16">
                                                                    <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                                                                </svg>
                                                           &nbsp;
                                                            <h5 className="text-secondary mb-2 fw-bold">{t("Supporting Documents")}</h5>
                                                             </div>
                                                            <p className="text-muted mb-3">{t("Optional additional files")}<br/>PDF, JPG, PNG (Max 10MB)</p>
                                                            <div className="btn btn-primary">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-files me-2" viewBox="0 0 16 16" style={{position:"relative",top:"2px"}}>
                                                                    <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                                                                </svg>&nbsp;
                                                                {t("Choose File")}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                          
                                        </div> 
                                        <div className='row'>
                                          <div className="col-12 d-flex justify-content-center mt-4">
  <div className="card "  style={{borderRadius:"10px", width: '100%'}}>
    {/* Gradient Header */}
    

    <div className="card-body">
      {/* Total Section */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="d-flex align-items-center gap-2">
          <i className="bi bi-cash-stack text-primary fs-4"></i>
          <h6 className="text-secondary fw-semibold mb-0 " style={{fontSize:"20px",fontWeight:"600"}}>{t("Total Amount")}</h6>
        </div>
        <h2 className="text-dark mb-0" style={{fontWeight:"600"}}>45 OMR</h2>
      </div>

    
    </div>
  </div>
</div>

                                            {/* Payment Button */}

                  <div className="col-12">
                  <div className="d-flex justify-content-between w-100 mt-4">
                 
                    
                    <button 
                      type="button" 
                      onClick={handleBackButton}
                      className="btn btn-primary btn-lg px-4"
                      style={{borderRadius:"5px",margin:"0px"}}
                    >
                      {t("Back to Form")}
                    </button>

                      <div>
         <button 
                      type="button" 
                      onClick={(e) => handleMakePayment(e)}
                      disabled={loading}
                      className="btn btn-primary btn-lg px-5 "
                    >
                     {loading ? t("Processing...") : t("Submit")+ " & "+ t("Pay")}
                    </button>
    </div>

                      
                  </div>      
                </div>
            </div>
            </div>
          </div>
        </div>
      </div>
   
      <Footer />
        {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
     <ToastContainer position="top-right" autoClose={5000} />
    </Fragment>
  );
}

export default OmanVisaSummary;